// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import p4Assem from './components/p4-assem.vue';
import '@/assets/css/tailwind.css';
import VueTextareaAutosize from "vue-textarea-autosize";

Vue.use(VueTextareaAutosize);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  render: h => h(p4Assem),
}).$mount('#app')
